class PaymentScenarioForm {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el
    this.$root.find('.js-geo-codes').select2()
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new PaymentScenarioForm($('.payment-scenario-form'))
})
